import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { TaskQueryKeys } from "@/service/TaskQueries";

export const useMutateDeleteTask = () => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (id: number) => SATOSPortal.DeleteTaskEvent(id),

		onMutate: async (taskId: number) => {
			void taskId;
			await queryClient.cancelQueries({ queryKey: [TaskQueryKeys.tasks] });
		},

		onSettled: () => {
			void queryClient.invalidateQueries({ queryKey: [TaskQueryKeys.tasks] });
		},
	});

	return mutation;
};

export const useMutateDeleteTaskComment = (
	onSuccessCallback?: (commentId: number) => void,
) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			commentId,
			taskId,
		}: {
			commentId: number;
			taskId: number;
		}) => SATOSPortal.DeleteTaskEventComment(commentId, taskId),
		onMutate: async () => {
			await queryClient.cancelQueries({ queryKey: [TaskQueryKeys.tasks] });
		},
		onSuccess: (_, { commentId }) => {
			if (onSuccessCallback) onSuccessCallback(commentId);
		},
		onSettled: () => {
			void queryClient.invalidateQueries({ queryKey: [TaskQueryKeys.tasks] });
		},
	});
};

export const useMutateCompleteTask = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			id,
			payload,
		}: {
			id: number;
			payload: Record<string, unknown>;
		}) => SATOSPortal.CompleteTaskEvent(id, payload),

		onMutate: async () => {
			await queryClient.cancelQueries({ queryKey: [TaskQueryKeys.tasks] });
			await queryClient.cancelQueries({
				queryKey: [TaskQueryKeys.recurringChildren],
			});
		},
		onSettled: () => {
			void queryClient.invalidateQueries({ queryKey: [TaskQueryKeys.tasks] });
			void queryClient.invalidateQueries({
				queryKey: [TaskQueryKeys.recurringChildren],
			});
		},
	});
};
